/**
 * Perfil del usuario (GEN-PX-006). Lógica pura: de dónde sale cada dato del perfil.
 *
 * El descriptor de sesión del kernel (`user`: id, display_name, rol, idioma) NO lleva email a propósito.
 * El email propio se lee del claim `email` del ID token de Cognito, que ya está en memoria en la sesión
 * (es el mismo token con el que el kernel mapea usuario -> rol). En mock, el descriptor sí lo trae.
 * No se llama a ningún endpoint nuevo ni se toca el kernel.
 */

/** Claim `email` del payload de un JWT (solo lectura, sin verificar: el kernel ya lo verifica); null si no hay. */
export function emailDeToken(token) {
  if (typeof token !== 'string') return null
  const trozos = token.split('.')
  if (trozos.length !== 3) return null
  try {
    const b64 = trozos[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(b64.padEnd(Math.ceil(b64.length / 4) * 4, '='))
        .split('').map(c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')).join(''),
    )
    const email = JSON.parse(json)?.email
    return typeof email === 'string' && email.trim() ? email.trim() : null
  } catch {
    return null
  }
}

/** Email propio: el del descriptor si lo trae (mock); si no, el del ID token. null si no hay ninguno. */
export const emailPropio = (user, token) => (user?.email ?? '').trim() || emailDeToken(token)
